
import { defineComponent, SetupContext, ref, computed } from "vue";
import NativeClient from "@/client/native-client";
import {PANTRY_FOOD_TYPE} from "@/types/pantry";

export default defineComponent({
  name: "PantryDetailMenuView",
  components: {
  },
  props: {
    type: {
      type: String,
      defalut: ""
    },
    push: {
      type: Number,
      default: -1
    }
  },
  setup(props, context: SetupContext) {
    const clickDelete = () => {
      context.emit("click-delete");
    };
    const clickClose = () => {
      context.emit("click-close");
    };
    const clickFoodChange = () => {
      context.emit("click-food-change");
    };
    const isShow = () => {
      return props.type == PANTRY_FOOD_TYPE.PLATE && props.push != 1;
    };
    const getDeleteText = () => {
      return (props.type == PANTRY_FOOD_TYPE.PLATE) ?
        "食材を削除する" : "リストから削除する";
    };
    return {
      clickDelete,
      clickClose,
      clickFoodChange,
      isShow,
      getDeleteText
    };
  }
});
